<template>
  <el-button
    type="info"
    :size="$store.state.buttonSize"
    @click="handleClick"
    v-bind="$attrs"
  >批量删除</el-button>
</template>

<script>
export default {
  name: 'RemoveButton',
  inheritAttrs: true,
  methods: {
    handleClick() {
      this.$confirm('此操作将永久删除数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$emit('click')
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    }
  }
}
</script>
